import React from "react";

const fillStars = (value) => {
  const stars = [];
  const maxStars = 5;

  for (let i = 1; i <= maxStars; i++) {
    if (value >= i || (i - value) < 0.25) {
      // Full star
      stars.push('star');
    } else if (0.25 <= Math.abs(i - value) && Math.abs(i - value) < 0.75 ) {
      // Half star
      stars.push('star half');
    } else {
      // Empty star
      stars.push('star empty');
    }
  }
  return stars;
}

const Rating = (props) => {
  const {value = 0} = props;
  const stars = fillStars(Math.min(value, 5.0));
  return (
    <span className="rating-stars">
      {
        stars.map((star, idx) =>(
          <span key={idx} className={`${star}`}></span>
        ))
      }
    </span>
  )
}

export default Rating;